import { Injectable } from '@angular/core';

declare const bootstrap: any;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private shownMessages: Set<string> = new Set();

  constructor() {}

  notify(message: string, type: 'success' | 'info' | 'warning' | 'danger' = 'info'): void {

    if (this.shownMessages.has(message)) {
      return;
    }

    this.shownMessages.add(message);

    const bgColorClass = this.getBgColorClass(type);

    const template = document.createElement('template');
    template.innerHTML = `
      <div class="toast align-items-center ${bgColorClass} text-white" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="3000">
        <div class="d-flex">
          <div class="toast-body">
            ${message}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>`.trim();

    const toastContainer = document.getElementById('toast-container');
    if (toastContainer && template.content.firstChild) {
      toastContainer.appendChild(template.content.firstChild);
      const toast = new bootstrap.Toast(toastContainer.lastChild);
      toast.show();

      if (toastContainer.lastChild) {
        toastContainer.lastChild.addEventListener('hidden.bs.toast', () => {
          this.shownMessages.delete(message);
        });
      }


    } else {
      console.error('Cannot find the toast container or toast element is null');
    }
  }

  private getBgColorClass(type: 'success' | 'info' | 'warning' | 'danger'): string {
    switch (type) {
      case 'success':
        return 'bg-success';
      case 'info':
        return 'bg-info';
      case 'warning':
        return 'bg-warning';
      case 'danger':
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }
}
